import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "auth",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().authSlice?.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),

  // Removed tagTypes to fix the error

  endpoints: (builder) => ({
    sendOtpCode: builder.mutation({
      query: (phoneNumber) => ({
        url: "/send_otp",
        method: "POST",
        body: { phone_number: phoneNumber },
      }),
      transformResponse: (response) => response.data,
    }),
    verifyOtpCode: builder.mutation({
      query: ({ phoneNumber, code, tempToken }) => ({
        url: "/verify",
        method: "POST",
        body: JSON.stringify({
          phone_number: phoneNumber,
          tmp_token: tempToken,
          verf_code: code,
        }),
      }),
    }),
    register: builder.mutation({
      query: ({
        phoneNumber,
        tempToken,
        firstName,
        lastName,
        nationalCode,
        birth,
        mail,
      }) => ({
        url: "/register",
        method: "POST",
        body: JSON.stringify({
          phone_number: phoneNumber,
          tmp_token: tempToken,
          first_name: firstName,
          last_name: lastName,
          national_code: nationalCode,
          birthday: birth || 0,
          mail,
        }),
      }),
    }),
  }),
});

export const {
  useSendOtpCodeMutation,
  useVerifyOtpCodeMutation,
  useRegisterMutation,
} = authApi;
